module.exports = __webpack_public_path__ + "static/media/car-marker.e9671562.svg";